<template>
	<div class="newListDiv">
		<div class="titleBox flexDiv margin-t50">
			<p>
				<em>师资建设</em>
				<span>FACULTY BUILDING</span>
			</p>
			<a v-if="moreLink" class="moreBtn wow zoomIn" data-wow-delay="0.3s">
				<router-link :to="moreLink"><i>查看更多+</i></router-link>
			</a>
		</div>
		<ul class="wutuUL">
			<li v-for="(item,index) in szjsList" :key="item.ID" class="wow fadeInRight" :data-wow-delay="index/8+'s'">
        <router-link  :to="item.Url" :href="item.Url" class="flexDiv">
          <p>{{item.ShowTime2}}<i>{{setTimeformat(item.ShowTime6,'YYYY-mm')}}</i></p>
          <span>{{item.Title}}</span>
        </router-link>
			</li>
		</ul>
	</div>
</template>

<script>
	export default{
		name:'szjs',
		props:{
			szjsList:{
				type:Array,
				default:()=>[]
			},
			moreLink: {
			   type: String,
			   default: ''
			},
		},
		methods:{
			setTimeformat(_data,_format='yyyy-mm-dd'){
				 return _format.replace(/YYYY/i,_data.substr(0,4)).replace(/MM/i,_data.substr(5,2)).replace(/DD/i,_data.substr(8,2))
			},
			hoverRoll(_data){
			  this.item = _data
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/szjs.vue